export const BannerDektonArtikCustomerList = [
    '0000409976',
    '0000411889',
    '0000707742',
    '0000412095',
    '0000421363',
    '0000417954',
    '0000424188',
    '0000421717',
    '0000421717',
    '0000414304',
    '0000423516',
    '0000418676',
    '0000413861',
    '0000426053',
    '0000413464',
    '0000413418',
    '0000413418',
    '0000410056',
    '0000410056',
    '0000413469',
    '0000415267',
    '0000415267',
    '0000420911',
    '0000416957',
    '0000416957',
    '0000413109',
    '0000413109',
    '0000413109',
    '0000413109',
    '0000427548',
    '0000427548',
    '0000431649',
    '0000414779',
    '0000702667',
    '0000413119',
    '0000413894',
    '0000413894',
    '0000413202',
    '0000413212',
    '0000413120',
    '0000413120',
    '0000413148',
    '0000413204',
    '0000413204',
    '0000413160',
    '0000409129',
    '0000411291',
    '0000411291',
    '0000411798',
    '0000409836',
    '0000414458',
    '0000412473',
    '0000415776',
    '0000412671',
    '0000419301',
    '0000412508',
    '0000413699',
    '0000431304',
    '0000417383',
    '0000419385',
    '0000419408',
    '0000419443',
    '0000419477',
    '0000410920',
    '0000411282',
    '0000411282',
    '0000408961',
    '0000415103',
    '0000411828',
    '0000412493',
    '0000408817',
    '0000424456',
    '0000424456',
    '0000412532',
    '0000412532',
    '0000417373',
    '0000419937',
    '0000420008',
    '0000420008',
    '0000425930',
    '0000425930',
    '0000418479',
    '0000418479',
    '0000418500',
    '0000418501',
    '0000419127',
    '0000418564',
    '0000418585',
    '0000419787',
    '0000420423',
    '0000425212',
    '0000418809',
    '0000418061',
    '0000418061',
    '0000409623',
    '0000415652',
    '0000410219',
    '0000411055',
    '0000410746',
    '0000413074',
    '0000411667',
    '0000408834',
    '0000409224',
    '0000409750',
    '0000413473',
    '0000412877',
    '0000412877',
    '0000440076',
    '0000409061',
    '0000409061',
    '0000423842',
    '0000437172',
    '0000410291',
    '0000438265',
    '0000438265',
    '0000411506',
    '0000416065',
    '0000429572',
    '0000412468',
    '0000409973',
    '0000410321',
    '0000412423',
    '0000430331',
    '0000413067',
    '0000413067',
    '0000410530',
    '0000411215',
    '0000411215',
    '0000709143',
    '0000410314',
    '0000410314',
    '0000411043',
    '0000411214',
    '0000420085',
    '0000417180',
    '0000411670',
    '0000412944',
    '0000409607',
    '0000412201',
    '0000413865',
    '0000408992',
    '0000711349',
    '0000409406',
    '0000437557',
    '0000412472',
    '0000408912',
    '0000408913',
    '0000410606',
    '0000409209',
    '0000409522',
    '0000432036',
    '0000433174',
    '0000409997',
]